import React, { useState } from "react";
import { Card, Modal, Page } from "@shopify/polaris";

// To truncate the text
const Truncate = ({ text, maxSize }) => {
  const [showFullText, setShowFullText] = useState(false);
  const strippedText = text.slice(0, maxSize);
  const checkMessageLength = () => {
    if (text.length > strippedText.length) {
      setShowFullText(true);
    }
  };

  if (strippedText) {
    return (
      <>
        <Modal
          medium
          open={showFullText}
          title="Message"
          onClose={() => setShowFullText(false)}
        >
          <Page>
            <Card>
              <Card.Section subdued>
                <div style={{ cursor: "default", wordWrap: "break-word" }}>
                  {text}
                </div>
              </Card.Section>
            </Card>
          </Page>
        </Modal>
        <div
          onClick={() => {
            checkMessageLength();
          }}
        >
          {`${strippedText}`}
          <span style={{ fontWeight: "bold", color: "green" }}>{`${
            text.length > strippedText.length ? " more..." : ""
          }`}</span>
        </div>
      </>
    );
  } else {
    return <></>;
  }
};

export default Truncate;
